import { MainApi } from "./MainApi";
import { CouponListSearchCondition } from "../types/coupon";

export class CouponApi {
  static baseUrl = `${MainApi.urlPrefix}/user/coupon`;

  static getCouponCount = () => () => MainApi.api.get(`${CouponApi.baseUrl}/count`);

  static getMyCouponList = (condition: CouponListSearchCondition) => () =>
    MainApi.api.get(`${CouponApi.baseUrl}${MainApi.toParamStringFromObject(condition)}`);
}
